import React, {Component} from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import {pushTopLevelMenuItemClick} from '../../../../helpers/gtm'
import MegaMenuItemSecondLevel from "./MegeMenuItemSecondLevel"
import MegaMenuImageBlock from "./MegeMenuImageBlock"
import {hasTrueValueInObj} from "../../../../helpers/utils"

const getPageNameGA4 = () => window?.drupalSettings?.g4DataLayerCommonVariables?.pagename;

export default class MegaMenuItem extends Component {
  static propTypes = {
    title: PropTypes.string,
    url: PropTypes.string.isRequired,
    index: PropTypes.number.isRequired,
    isExpanded: PropTypes.bool,
    isCollapsed: PropTypes.bool,
    inActiveTrail: PropTypes.bool,
    subtree:  PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.object,
    ]),
    obfuscate: PropTypes.bool,
    disableForLanguage: PropTypes.bool,
    class: PropTypes.string,
    classStyle: PropTypes.string,
    imagesBlock:  PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.object,
    ]),
  }

  static defaultProps = {
    title: '',
    url: '',
    isExpanded: false,
    isCollapsed: false,
    inActiveTrail: false,
    subtree: {},
    obfuscate: false,
    disableForLanguage: false,
    class: '',
    classStyle: ''
  }

  state = {
    secondLevelIsOpen: false,
    hasThirdLevel: false,
  }

  constructor(props) {
    super(props)
    this.menuRef = React.createRef()
    this.handleClickOutside = this.handleClickOutside.bind(this)
    this.state = {
      thirdLevelIsOpenStates: {},
      hasPreselectedSecondLevel: false,
      thirdLevelIsOpen: false,
    };
  }

  addClassToBodyWhenMenuOpen(open) {
    const body = document.querySelector('body')
    if (open) {
      body.classList.add('megamenuopen')
    } else {
      body.classList.remove('megamenuopen')
    }
  }

  componentDidMount() {
    const {
      subtree,
    } = this.props

    let preselectedAlready = false

    const updatedChildStatesThirdLevels = {}
    document.addEventListener('mousedown', this.handleClickOutside)
    this.checkIfThirdLevelExist()

    Object.keys(subtree).forEach((key) => {
      const preselectedFromBO = subtree[key].preselected
      let preselect = false
      if (preselectedFromBO && !preselectedAlready) {
        preselectedAlready = true
        preselect = true
      }
      updatedChildStatesThirdLevels[key] = preselect
    });

    this.setState({
      thirdLevelIsOpenStates: updatedChildStatesThirdLevels,
      hasPreselectedSecondLevel: preselectedAlready,
    });
  }

  updateStatesThirdLevels = (childId, newState) => {
    const { thirdLevelIsOpenStates } = this.state;
    const updatedChildStatesThirdLevels = {};

    // Set the clicked child to true and the rest to false
    if (Object.keys(thirdLevelIsOpenStates).length > 0) {
        Object.keys(thirdLevelIsOpenStates).forEach((key) => {
          updatedChildStatesThirdLevels[key] = key === childId ? newState : false;
        });
    } else {
      updatedChildStatesThirdLevels[childId] = newState;
    }

    this.setState({
      thirdLevelIsOpenStates: updatedChildStatesThirdLevels,
      thirdLevelIsOpen: hasTrueValueInObj(updatedChildStatesThirdLevels),
    });
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside)
  }

  pushGTMEvent = () => {
    const {gtmDataTrack, index} = this.props;
    if (gtmDataTrack) {
      pushTopLevelMenuItemClick({
        pagename: getPageNameGA4(),
        type: gtmDataTrack,
        index: index + 1
      })
    }
  }

  toggleMenuSecondLevel = (event) => {
    const {
      secondLevelIsOpen,
    } = this.state
    // Keypresses other than Enter and Space should not trigger a command
    if (event) {
      if (
        event.type === "keydown" &&
        event.key !== "Enter" &&
        event.key !== " "
      ) {
        return;
      }
    }
    this.pushGTMEvent()
    this.setState({secondLevelIsOpen: !secondLevelIsOpen})
    this.addClassToBodyWhenMenuOpen(!secondLevelIsOpen)
  }

  closeMenuSecondLevel = () => {
    this.setState({secondLevelIsOpen: false})
    this.addClassToBodyWhenMenuOpen(false)
  }

  handleClickOutside = (event) => {
    if (this.menuRef.current && !this.menuRef.current.contains(event.target) &&
      event.target.closest('.megamenu__second-level') === null) {
      // Clicked outside the menu, so close it
      this.closeMenuSecondLevel()
    }
  }

  renderLink = () => {
    const {
      title,
      url,
      subtree,
      obfuscate,
      obfuscateDataUrl,
      gtmDataTrack,
      attributes,
    } = this.props

    let classFromBO = ''
    let targetFromBO = ''

    if (typeof attributes === 'object') {
       classFromBO = attributes.class
       targetFromBO = attributes.target
    }

    const {secondLevelIsOpen} = this.state

    const hasChildren = Object.keys(subtree).length > 0

    if (obfuscate && !hasChildren) {
      // obfuscated link
      return (
        <span
          aria-label={title}
          role={'button'}
          tabIndex="0"
          className={cn(classFromBO,  'obfuscate' )}
          onClick={this.pushGTMEvent}
          data-link={obfuscateDataUrl} data-target={targetFromBO}>
          {title}
        </span>
      )
    } else if (hasChildren) {
      // Second level trigger
      return (
        <span
          aria-label={title}
          role={'button'}
          tabIndex="0"
          className={cn(classFromBO, secondLevelIsOpen ? 'active' : '')}
          onClick={this.toggleMenuSecondLevel}
          onKeyDown={this.toggleMenuSecondLevel}
        >
          {title}
        </span>
      )
    } else {
      // default link
      return (
        <a
          href={url}
          aria-label={title}
          tabIndex="0"
          className={cn(classFromBO)}
          onClick={this.pushGTMEvent}
          data-target={targetFromBO}>
          {title}
        </a>
      )
    }
  }

  checkIfThirdLevelExist() {
    const {
      subtree,
    } = this.props

    function hasSubtreeWithItems(obj) {
      for (const key in obj) {
        if (obj[key].subtree && Object.keys(obj[key].subtree).length > 0) {
          return true
        }
        if (typeof obj[key] === 'object') {
          if (hasSubtreeWithItems(obj[key])) {
            return true
          }
        }
      }
      return false
    }

    this.setState({hasThirdLevel: hasSubtreeWithItems(subtree)})

  }

  render() {
    const {
      classStyle,
      subtree,
      disableForLanguage,
      imagesBlock,
      hideMenuItem,
    } = this.props

    const {
      secondLevelIsOpen,
      hasThirdLevel,
      hasPreselectedSecondLevel,
      thirdLevelIsOpen,
    } = this.state

    const isFrLang = window?.drupalSettings?.path?.currentLanguage === 'fr';

    return (
      <React.Fragment>
        {!disableForLanguage && !hideMenuItem &&
          <div
            className={cn('megamenu__item megamenu__item_first-level', {'megamenu__item_first-level-fr': isFrLang}, classStyle)}
            ref={this.menuRef}
          >
            {this.renderLink()}

            {secondLevelIsOpen &&
              <div className="megamenu__second-level">
                <span className="megamenu__second-level-close" onClick={this.closeMenuSecondLevel}/>
                <div className={cn('megamenu__second-level-container', hasThirdLevel && (hasPreselectedSecondLevel || thirdLevelIsOpen) ? 'hasThirdLevel' : '')}>
                  {/*hasThirdLevel*/}
                  <div className="megamenu__second-level-items-list"></div>

                  {Object.keys(subtree).map((key, index) => {
                      {
                        return <MegaMenuItemSecondLevel
                          {...subtree[key]}
                          key={key}
                          id={key}
                          thirdLevelIsOpen={this.state.thirdLevelIsOpenStates[key] || false}
                          updateChildState={this.updateStatesThirdLevels}
                        />
                      }
                    }
                  )}

                  {!hasPreselectedSecondLevel && !thirdLevelIsOpen &&
                    //
                    // In case parent first level item was setted to move to second level it will not containe
                    // imageBlock, so  we take image block of first third-level item
                    //
                    <React.Fragment>
                      <div className="megamenu__second-level-image-block">
                        {imagesBlock ? (
                          <React.Fragment>
                            {imagesBlock && imagesBlock.images && imagesBlock.images.map((image, index) => {
                                return <MegaMenuImageBlock {...image} key={image.url + index}/>
                              })
                            }
                          </React.Fragment>
                        ) : (
                          <React.Fragment>
                            {Object.values(subtree)[0].imagesBlock && Object.values(subtree)[0].imagesBlock.images && Object.values(subtree)[0].imagesBlock.images.map((image, index) => {
                                return <MegaMenuImageBlock {...image} key={image.url + index}/>
                              })
                            }
                          </React.Fragment>
                        )}
                      </div>
                    </React.Fragment>
                  }
                </div>
              </div>
            }
          </div>
        }
      </React.Fragment>
    )
  }
}
